export const REACT_APP_BACKEND_SERVER_URL =
  process.env.REACT_APP_BACKEND_SERVER_URL || "";
